import { EPaletteModes } from "@/types/theme-packs";

const cache = new Map<string, string | undefined>();

const getComputedColorVariableValue = (
	variable: string,
	themeMode?: EPaletteModes,
	dynamicKeyPrefix?: string | number
): string | undefined => {
	const mode = themeMode || document.body?.getAttribute('data-color-mode') || EPaletteModes.Dark;

	const cacheKey = `${dynamicKeyPrefix ? `${dynamicKeyPrefix}-` : ''}${mode}-${variable}`;
	// check if the variable is already cached
	if (cache.has(cacheKey)) {
		return cache.get(cacheKey);
	}

	if (cache.size > 100) {
		// clear the cache if it exceeds 100 entries
		cache.clear();
	}

	// ensure we are using the correct root element so the CSS variable is resolved correctly based on the theme
	// we need to do this because the we override the css variables in the body element for light mode (see color-scale.css)
	const rootSelector = `body[data-color-mode="${mode}"]`;
	const rootElement = document.querySelector(rootSelector) || document.documentElement;
	const rootStyle = window.getComputedStyle(rootElement);

	if (variable.startsWith('--') || variable.startsWith('var(--')) {
		// remove `var(` and `)` from the variable if it exists
		const _variable = variable.replace(/var\((--[^), ]+).*\)/, '$1').trim();
		const computedValue = rootStyle.getPropertyValue(_variable);
		// cache the computed value
		cache.set(cacheKey, computedValue);
		return computedValue;
	}

	cache.set(cacheKey, variable);
	return variable;
};

export default getComputedColorVariableValue;